export default {
  items: state => state.items,
  triggers: state => state.triggers,
  actives: state => state.actives,
  isactive: (state) => (id) => {
    let item = state.actives.find(item => item === id)
    return item !== undefined
  }
}
